/* eslint-disable */
import { Field } from "react-final-form";

export default function BankDetailsForm() {
  return (
    <div className="col-xl-6 col-lg-12">
      <div className="form-group-bank">
        <div className="input-block mb-3 notes-form-group-info">
          <label>Customer Notes</label>
          <Field
            name="customer_notes"
            component="textarea"
            className="form-control"
            placeholder="Enter Internal Notes"
          />
        </div>
        <div className="input-block mb-3 notes-form-group-info mb-0">
          <label>Terms and Conditions</label>
          <Field
            name="terms"
            component="textarea"
            className="form-control"
            placeholder="Enter Terms and Conditions"
          />
        </div>
      </div>
    </div>
  );
}
